// extracted by mini-css-extract-plugin
module.exports = {"body":"CardBody_body__3jTG_","value":"CardBody_value__7WWQA","incidentInfo":"CardBody_incidentInfo__1HLLw","customLabel":"CardBody_customLabel__g8ikU"};